module.exports = {"410503001":"红旗路街道","410503003":"解放路街道","410503004":"灯塔路街道","410503005":"豆腐营街道","410503006":"洹北街道","410503008":"彰东街道","410503009":"彰北街道","410503010":"民航路街道","410503011":"曙光路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410503.json
// module id = 1437
// module chunks = 0